import { render, staticRenderFns } from "./COM_Header.vue?vue&type=template&id=57d813ac&scoped=true&"
import script from "./COM_Header.vue?vue&type=script&lang=js&"
export * from "./COM_Header.vue?vue&type=script&lang=js&"
import style0 from "./COM_Header.vue?vue&type=style&index=0&id=57d813ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d813ac",
  null
  
)

export default component.exports